/* Native form submission is retained; this only refreshes the selected variant UI. */
document.addEventListener('click', (event) => {
  const link = event.target.closest?.('.sh-mobile-menu a');
  if (link) link.closest('details').open = false;
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const menu = document.querySelector('.sh-mobile-menu[open]');
  if (menu) {
    menu.open = false;
    menu.querySelector('summary').focus();
  }
});

if (!customElements.get('solid-home-product')) {
  customElements.define('solid-home-product', class extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.abortController = new AbortController();
      this.addEventListener('change', (event) => {
        if (!event.target.matches('[data-variant-select]')) return;
        const option = event.target.selectedOptions[0];
        const button = this.querySelector('[data-submit]');
        this.querySelector('[data-price]').textContent = option.dataset.price;
        button.disabled = option.dataset.available !== 'true';
        this.querySelector('[data-button-label]').textContent = button.disabled ? 'Uitverkocht' : button.dataset.label;
      }, { signal: this.abortController.signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
    }
  });
}
